import { ObjectField } from "../models/ObjectField";

export class QueryFilter {
    Id: number | string | null;
    Tenant: number;
    QueryCode: string;
    ObjectFieldCode: string | null;
    ObjectField: ObjectField | null;
    Operator: string;
    Value: string | null;
    IsDeleted: boolean;
    Condition: string | null;
}